const GAME_OBJECTS = {
    car: {
        id: "car",
        number: 1,
        image: "/images/game/chapter3/game-objects/min-car.png",
        title: "洗車",
        description: "趁雨水豐沛拿來洗車可以省水真讚！",
        status: {
            default: "/images/game/chapter3/game-objects/min-car.png",
            done: "/images/game/chapter3/game-objects/min-car-done.png",
        },
        position: {
            x: 1383,
            y: 268
        },
        size: {
            width: 406,
            height: 295,
        },
    },
    sandbag: {
        id: "sandbag",
        visibilityMode: "whenNotDone",
        number: 2,
        stars: 4,
        image: "/images/game/chapter3/game-objects/min-sandbag.png",
        title: "堆沙包",
        description: "沙包的吸水性可以防止住家的淹水。",
        importance: "門口堆沙包防止雨水倒灌，減少淹水風險。",
        status: {
            default: "/images/game/chapter3/game-objects/min-sandbag.png",
            done: "/images/game/chapter3/game-objects/min-sandbag-done.png",
        },
        position: {
            x: 1616,
            y: 663
        },
        size: {
            width: 180,
            height: 147,
        },
    },
    sandbagDone: {
        id: "sandbag",
        visibilityMode: "whenDone",
        number: 2,
        stars: 4,
        image: "/images/game/chapter3/game-objects/min-sandbag.png",
        title: "堆沙包",
        description: "沙包的吸水性可以防止住家的淹水。",
        importance: "門口堆沙包防止雨水倒灌，減少淹水風險。",
        position: {
            x: 813,
            y: 727
        },
        size: {
            width: 180,
            height: 147,
        },
        status: {
            default: "/images/game/chapter3/game-objects/min-sandbag-done.png",
            done: "/images/game/chapter3/game-objects/min-sandbag-done.png",
        },
    },
    sewer: {
        id: "sewer",
        number: 3,
        stars: 4,
        image: "/images/game/chapter3/game-objects/min-sewer.png",
        title: "疏通排水溝",
        description: "預防淹水就必須保持排水系統暢通。",
        importance: "清理水溝雜物，確保排水順暢，減少淹水。",
        status: {
            default: "/images/game/chapter3/game-objects/min-sewer.png",
            done: "/images/game/chapter3/game-objects/min-sewer-done.png",
        },
        position: {
            x: 636,
            y: 872
        },
        size: {
            width: 269,
            height: 181,
        },
    },
    statue: {
        id: "statue",
        visibilityMode: "whenNotDone",
        number: 4,
        image: "/images/game/chapter3/game-objects/min-statue.png",
        title: "建造雕像",
        description: "是讓庭院增添中世紀風格的好時機。",
        status: {
            default: "/images/game/chapter3/game-objects/min-statue.png",
            done: "/images/game/chapter3/game-objects/min-statue.png",
        },
        position: {
            x: 1274,
            y: 755
        },
        size: {
            width: 227,
            height: 153,
        },
    },
    statueDone: {
        id: "statue",
        visibilityMode: "whenDone",
        number: 4,
        image: "/images/game/chapter3/game-objects/min-statue.png",
        title: "建造雕像",
        description: "是讓庭院增添中世紀風格的好時機。",
        status: {
            default: "/images/game/chapter3/game-objects/min-statue-done.png",
            done: "/images/game/chapter3/game-objects/min-statue-done.png",
        },
        position: {
            x: 1274,
            y: 531
        },
        size: {
            width: 227,
            height: 377,
        },
    },
    tree: {
        id: "tree",
        number: 5,
        stars: 4,
        image: "/images/game/chapter3/game-objects/min-tree.png",
        title: "修剪樹木枝幹",
        description: "避免猖狂的樹枝被吹倒摧毀到我家。",
        importance: "修剪樹枝降低被吹斷掉落造成危險的機率。",
        status: {
            default: "/images/game/chapter3/game-objects/min-tree.png",
            done: "/images/game/chapter3/game-objects/min-tree-done.png",
        },
        position: {
            x: 906,
            y: 80
        },
        size: {
            width: 553,
            height: 436,
        },
    },
    flower_1: {
        id: "flower",
        number: 6,
        image: "/images/game/chapter3/game-objects/min-flower-1.png",
        title: "種花",
        description: "在下豪雨的時候種花一定會長得很快！",
        status: {
            default: "/images/game/chapter3/game-objects/min-flower-1.png",
            done: "/images/game/chapter3/game-objects/min-flower-1-done.png",
        },
        position: {
            x: 439,
            y: 600
        },
        size: {
            width: 258,
            height: 182,
        },
    },
    flower_2: {
        id: "flower",
        number: 6,
        image: "/images/game/chapter3/game-objects/min-flower-2.png",
        title: "種花",
        description: "在下豪雨的時候種花一定會長得很快！",
        status: {
            default: "/images/game/chapter3/game-objects/min-flower-2.png",
            done: "/images/game/chapter3/game-objects/min-flower-2-done.png",
        },
        position: {
            x: 665,
            y: 429
        },
        size: {
            width: 303,
            height: 200,
        },
    },
    plant: {
        id: "plant",
        number: 7,
        stars: 4,
        image: "/images/game/chapter3/game-objects/min-plant.png",
        title: "盆栽移入室內",
        description: "盆栽才不會被吹飛造成周遭的危險。",
        importance: "避免強風吹倒盆栽砸傷人或損壞財物。",
        status: {
            default: "/images/game/chapter3/game-objects/min-plant.png",
            done: "/images/game/chapter3/game-objects/min-plant-done.png",
        },
        position: {
            x: 451,
            y: 348
        },
        size: {
            width: 121,
            height: 170,
        },
    },
    wall_1: {
        id: "wall",
        number: 8,
        image: "/images/game/chapter3/game-objects/min-wall-1.png",
        title: "裝飾牆壁",
        description: "家外牆貼上門神可以保佑自家安全。",
        status: {
            default: "/images/game/chapter3/game-objects/min-wall-1.png",
            done: "/images/game/chapter3/game-objects/min-wall-1-done.png",
        },
        position: {
            x: 568,
            y: 670
        },
        size: {
            width: 240,
            height: 301,
        },
    },
    wall_2: {
        id: "wall",
        number: 8,
        image: "/images/game/chapter3/game-objects/min-wall-2.png",
        title: "裝飾牆壁",
        description: "家外牆貼上門神可以保佑自家安全。",
        status: {
            default: "/images/game/chapter3/game-objects/min-wall-2.png",
            done: "/images/game/chapter3/game-objects/min-wall-2-done.png",
        },
        position: {
            x: 915,
            y: 496
        },
        size: {
            width: 223,
            height: 284,
        },
    },
    window: {
        id: "window",
        number: 9,
        stars: 4,
        image: "/images/game/chapter3/game-objects/min-window.png",
        title: "緊閉門窗",
        description: "防止風吹雨打侵襲我家舒適的室內。",
        importance: "防止強風豪雨灌入屋內，維護居家安全。",
        status: {
            default: "/images/game/chapter3/game-objects/min-window.png",
            done: "/images/game/chapter3/game-objects/min-window-done.png",
        },
        position: {
            x: 514,
            y: 220
        },
        size: {
            width: 126,
            height: 137,
        },
    },
};

export default GAME_OBJECTS;
